const API_ENDPOINTS = {
    recommendations: `api/recommends/tests/`,
    recommendationsTracker: `api/recommends/tests/save`,
    tests: `api/`,
    results: `api/attempts`,
    lastAttempt: `api/attempts/last/`,
    historyResults: `/api/attempts/history/`,
    reportForm: `api/questions/report`,
    ratingForm: `api/attempts/rating`,

    checkDomain: `api/wgt/domains/check/`,
    checkWidgetExisting: `api/wgt/tests/`,
    postWidget: `api/wgt`,
    getDomainList: `api/wgt/domains`,
    postNewDomain: `api/wgt/domains`,
    deleteDomain: `api/wgt/domains/`,
    deleteWidget: `api/wgt/`,
    checkWidgetAccess: `api/wgt/tests/access/`,

};

export default API_ENDPOINTS;

